import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

const SLUG = 'default';

export interface WebsiteAbout {
  id: string;
  slug: string;
  background_image_url: string | null;
  home_blurb: string | null;
  updated_at: string;
}

export function useWebsiteAbout() {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['websiteAbout'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('website_about')
        .select('id, slug, background_image_url, home_blurb, updated_at')
        .eq('slug', SLUG)
        .maybeSingle();
      if (error) throw error;
      return data as WebsiteAbout | null;
    },
  });

  const updateMutation = useMutation({
    mutationFn: async (payload: { background_image_url?: string | null; home_blurb?: string | null }) => {
      const { data, error } = await supabase
        .from('website_about')
        .upsert(
          { slug: SLUG, ...payload, updated_at: new Date().toISOString() },
          { onConflict: 'slug' }
        )
        .select()
        .single();
      if (error) throw error;
      return data as WebsiteAbout;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['websiteAbout'] }),
  });

  return {
    about: query.data ?? null,
    loading: query.isLoading,
    error: query.error,
    update: updateMutation.mutateAsync,
    updateLoading: updateMutation.isPending,
  };
}
